<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card border border-radius-12">

          <div class="card-body table mb-0">
                        <div class="toolbar-container px-3">
              <div class="toolbar-row d-flex align-items-center justify-content-between mb-2">
                <PageHeader :title="title" :items="items" class="poppins fw-normal ps-0 text-nowrap" />
                <div class="d-flex gap-2 flex-wrap p-0 buttons-container">
                  <CustomButton 
                    :buttonText="downloadReportProcessing ? 'Please wait...' : 'Download Report'"
                    :loading = "downloadReportProcessing"
                    class="p-0"
                    @click="downloadReport" 
                  />
                </div>
              </div>

              <div class="toolbar-row d-flex gap-2 align-items-center">
                <searchInput @getSearched="handleSearch" class="p-0" />
                <pageSize @getPageSize="handlePageSize" class="page-size-btn p-0" />    
              </div>
            </div>
                <!-- <div class="d-flex align-items-center gap-lg-5 gap-2 top-section custom-gap">
                  <PageHeader :title="title" :items="items" class="poppins fw-normal text-nowrap" />
                  <searchInput @getSearched="handleSearch" class="w-100" />
                  <pageSize @getPageSize="handlePageSize" />

                  <div class="d-flex justify-content-end gap-2 mt-xl-0">
                    <div class="add_new rounded-pill p-0">
                      <button @click="downloadReport"
                        class="btn btn-primary border-0 px-4 fw-bold text-white waves-effect waves-light w-md primary-button rounded-pill text-nowrap btn-padding"
                        :disabled="downloadReportProcessing">
                        {{ downloadReportProcessing ? 'Please wait...' : 'Download Report' }}
                      </button>
                    </div>
                  </div>
            </div> -->
            <GeneralTable :isProcessing="processing" :items="items" :fields="fields" @no-records-found="onRecordsFount"
              :showEyeButton="true" :showActionButton="false" @showItem="showInovice">
            </GeneralTable>
            <b-modal ref="invoice-modal" hide-footer isModalVisible title="Invoice Details" size="lg">
              <template v-slot:default>
                <div v-if="loading">
                  <APILoader :loading="loading" class="align-middle text-center"></APILoader>
                </div>

                <div v-else>
                  <div class="invoice-info">
                    <div class="invoice-column">
                      <p><strong>Customer Email:</strong> {{ invoiceData?.customer_email ?? 'N/A' }}</p>
                      <p><strong>Amount Due:</strong> {{ formatAmount(invoiceData?.amount_due) ?? 'N/A' }}</p>
                      <p><strong>Amount Paid:</strong> {{ formatAmount(invoiceData?.amount_paid) ?? 'N/A' }}</p>
                      <p><strong>Amount Remaining:</strong> {{ formatAmount(invoiceData?.amount_remaining) ?? 'N/A' }}
                      </p>
                      <p><strong>End Date:</strong> {{ subscriptionEndDate }}</p>
                      <p><strong>Discount:</strong> {{ discountType }}</p>
                      <p><strong>Status:</strong> {{ invoiceData?.status ?? 'N/A' }}</p>
                    </div>
                    <div class="invoice-column">
                      <h6 class="mt-4"><strong>Items</strong></h6>
                      <div v-for="lineItem in invoiceData?.lines?.data" :key="lineItem.id" class="mb-3">
                        <p><strong>Description:</strong> {{ lineItem?.description }}</p>
                        <p><strong>Amount:</strong> {{ formatAmount(lineItem?.amount) }}</p>
                        <p><strong>Quantity:</strong> {{ lineItem?.quantity }}</p>
                      </div>
                      <p>
                        <strong>Invoice PDF:</strong>
                        <a :href="invoiceData?.invoice_pdf" target="_blank">View PDF</a>
                      </p>
                      <p>
                        <strong>Hosted Invoice URL:</strong>
                        <a :href="invoiceData?.hosted_invoice_url" target="_blank">View Invoice</a>
                      </p>
                    </div>
                  </div>
                </div>
              </template>
            </b-modal>
            <Pagination @paginator="userPayment" :pagination="paginatelinks" :showing="paginate"
              @page-changed="handlePageChange" />
            <!-- end table-responsive -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import $ from "jquery";
import GeneralTable from "../../../../components/MagicTable/GeneralTable.vue";
import Pagination from "../../../../components/general/pagination.vue";
import searchInput from "../../../../components/general/searchInput.vue";
import pageSize from "../../../../components/general/pageSize.vue";
import CustomButton from "../../../../components/CustomButton.vue";
export default {
  page: {
    title: "Subscription Listing",
    meta: [
      {
        name: "users-payment",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    GeneralTable,
    Pagination,
    searchInput,
    pageSize,
    CustomButton
  },

  data() {
    return {
      currentPageNumber: null,
      fields: [
        { key: 'id' },
        { key: 'name', label: 'Name', tdClass: 'align-middle' },
        { key: 'email', tdClass: 'align-middle' },
        { key: 'mobile', label: 'Phone', tdClass: 'align-middle' },
        { key: 'subscription_name', label: 'Subscription Name' },
        { key: 'stripe_status', label: 'Stripe Status', tdClass: 'align-middle' },
        { key: 'invoice_status', label: 'Invoice Status', tdClass: 'align-middle' },
        { key: 'paid_amount', label: 'Paid Amount', tdClass: 'align-middle' },
        { key: 'subscription_start', label: 'Subscription Start', tdClass: 'align-middle' },
        { key: 'subscription_end', label: 'Subscription End', tdClass: 'align-middle' },
        { key: 'discount', label: 'Discount Status', tdClass: 'align-middle' },
        { key: 'action', tdClass: '' },
      ],
      sort_by: '',
      selectedRows: [],
      items: [],
      currentPage: 1,
      itemsPerPage: 10,
      multipuleIds: [],
      selectAll: false,
      loading: true,
      users: null,
      paginatelinks: [],
      title: "Subscription Listing",
      processing: false,
      paginate: {},
      pageSize: 10,
      invoiceData: null,
      subscriptionEndDate: null,
      discountType: null,
      downloadReportProcessing: false,
      searchTerm: null,
    };
  },

  mounted() {
    let url = null;
    if (this.$route.query.currentPage) {
      url = process.env.VUE_APP_BASEURL + '/subscription-payments-?page=' + this.$route.query.currentPage;
    }
    this.userPayment({ url, pageSize: this.pageSize });
    this.processing = true;
  },
  computed: {
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.items.slice(start, start + this.itemsPerPage);
    }
  },
  methods: {
    formatAmount(amount) {
      return `$${(amount / 100).toFixed(2)}`;
    },
    showInovice(userId) {
      this.loading = true;
      this.invoiceData = null;
      this.fetchInvoice(userId);
    },
        formatDateTime(isoDate) {
      if (!isoDate) return "N/A";

      const date = new Date(isoDate);
      if (isNaN(date.getTime())) {
        return isoDate;
      }

      const options = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };

      return date.toLocaleString(undefined, options);
    },
    fetchInvoice(userId) {
      this.$axios
        .get(`invoices`, { params: { user_id: userId } })
        .then(response => {
          this.openPopup();
          this.loading = false;
          console.log(response.data.subscription.created_at);
          let createdAt = new Date(response.data.subscription.created_at);
          createdAt.setFullYear(createdAt.getFullYear() + 1);
          this.subscriptionEndDate = this.formatDate(createdAt.toISOString());
          this.invoiceData = response.data.invoices;
          this.discountType = response.data.discountType;
        })
        .catch(error => {
          console.error('Error fetching invoices:', error);
          this.loading = false;
        });
    },

    async downloadReport() {
      if (this.downloadReportProcessing) return;

      if (!this.items || this.items.length === 0) {
        if (typeof this.triggerSwal === "function") {
          this.triggerSwal("No data available to download.", "warning");
        } else {
          alert("No data available to download.");
        }
        return;
      }

      this.downloadReportProcessing = true;

      try {
        const total = this.paginate?.total || this.items.length;
        let allItems = [];

        if (!total || total <= this.items.length) {
          allItems = this.items;
        } else {
          const response = await this.$axios.get("subscription-payments", {
            params: {
              search: this.searchTerm,
              sort_by: this.sort_by,
              page_size: total,
            },
          });

          const paymentData = response?.data?.data;
          const users = Array.isArray(paymentData?.data) ? paymentData.data : [];

          allItems = users.map((user) => {
            const hasSubscription = Array.isArray(user.subscriptions) && user.subscriptions.length > 0;
            const subscription = hasSubscription ? user.subscriptions[0] : null;
            const subscriptionName = subscription?.name;
            const stripeStatus = subscription?.stripe_status || "No Subscription";
            const invoiceStatus =
              subscription?.invoice_status ||
              subscription?.status ||
              stripeStatus ||
              "N/A";
            const paidAmount = user.amount_paid ?? 0;
            const subscriptionStart = subscription?.created_at
              ? this.formatDateTime(subscription.created_at)
              : "N/A";
            const subscriptionEnd = subscription?.subscription_end_date
              ? this.formatDateTime(subscription.subscription_end_date)
              : (subscription?.trial_ends_at
                ? this.formatDateTime(subscription.trial_ends_at)
                : "N/A");

            return {
              id: user.id,
              name: user.full_name,
              email: user.email,
              mobile: user.mobile,
              subscription_name: subscriptionName,
              stripe_status: stripeStatus,
              invoice_status: invoiceStatus,
              paid_amount: this.formatAmount(paidAmount),
              subscription_start: subscriptionStart,
              subscription_end: subscriptionEnd,
              discount: user.discount,
              registeredon: user.created_at_formatted,
            };
          });
        }

        if (!allItems.length) {
          this.triggerSwal?.("No data available to download.", "warning");
          return;
        }

        const headers = [
          "ID",
          "Name",
          "Email",
          "Phone",
          "Subscription Name",
          "Stripe Status",
          "Invoice Status",
          "Paid Amount",
          "Subscription Start",
          "Subscription End",
          "Discount Status",
          "Registered On",
        ];

        const rows = allItems.map((user) => [
          user.id,
          user.name,
          user.email,
          user.mobile,
          user.subscription_name,
          user.stripe_status,
          user.invoice_status,
          user.paid_amount,
          user.subscription_start,
          user.subscription_end,
          user.discount,
          user.registeredon,
        ]);

        let csvContent = "";
        csvContent += headers.join(",") + "\n";

        rows.forEach((row) => {
          csvContent +=
            row
              .map((value) =>
                `"${String(value ?? "")
                  .replace(/"/g, '""')
                  .replace(/\n/g, " ")}"`
              )
              .join(",") + "\n";
        });

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `subscription-payments-${Date.now()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        this.triggerSwal?.("Something went wrong while generating report.", "error");
      } finally {
        this.downloadReportProcessing = false;
      }
    },

    openPopup() {
      this.$refs['invoice-modal'].show();
    },
    hideModal() {
      return this.$refs['invoice-modal'].hide();
    },

    onRecordsFount() {
      this.userPayment({ pageSize: this.pageSize, searchItem: null, sortBy: null });
      this.currentPage = 1;
    },
    handlePageChange(pageNumber) {
      if (pageNumber <= 0) {
        this.triggerSwal("Page not found. Please enter a valid page number.", "error");
        return;
      }

      const lastPageUrl = this.paginate?.last_page;
      let lastPage = 1;
      if (lastPageUrl) {
        const match = lastPageUrl.match(/page=(\d+)/);
        if (match && match[1]) {
          lastPage = parseInt(match[1], 10);
        }
      }

      if (pageNumber > lastPage) {
        this.triggerSwal("Page not found. Please enter a valid page number.", "error");
        return;
      }
      const baseUrl = "subscription-payments";
      const pageUrl = `${baseUrl}?page=${pageNumber}`;
      this.userPayment({ url: pageUrl, pageSize: this.pageSize });
    },
    deleteUser(id) {
      let apiUrl = `delete-user/`;
      let confirmationMessage = "User deleted successfully."
      this.processing = true;
      this.deleteIt(apiUrl, id, confirmationMessage)
        .then(() => {
          this.processing = false;
          this.userPayment({});
        }).catch(error => {
          console.error('Error deleting job:', error);
          this.processing = false;
        });
    },
    handleSearch(searchItem) {
      this.searchTerm = searchItem;
      this.userPayment({ searchItem, pageSize: this.pageSize });
    },
    filtration() {
      this.userPayment({ sortBy: this.sort_by, pageSize: this.pageSize });
    },
    updateCurrentPage(newPage) {
      this.currentPage = newPage;
    },
    handlePageSize(newPageSize) {
      this.pageSize = newPageSize || 10;
      this.userPayment({ pageSize: this.pageSize });
    },
    randerData(response) {
      const paymentData = response?.data?.data;

      this.currentPageNumber = paymentData.current_page;
      this.paginate = {
        first_page: paymentData.first_page_url,
        last_page: paymentData.last_page_url,
        links: paymentData.links,
        from: paymentData.from,
        to: paymentData.to,
        total: paymentData.total,
      };
      this.paginatelinks = this.paginate.links.map((item) => ({
        url: item.url,
        label: item.label,
        active: item.active,
      }));

      let users = Array.isArray(paymentData?.data) && paymentData?.data.length > 0
        ? paymentData?.data
        : [];
      this.items = users.map((user) => {
        const hasSubscription = Array.isArray(user.subscriptions) && user.subscriptions.length > 0;
        const subscription = hasSubscription ? user.subscriptions[0] : null;
        const subscriptionName = subscription?.name;
        const stripeStatus = subscription?.stripe_status || "No Subscription";
        const invoiceStatus =
          subscription?.invoice_status ||
          subscription?.status ||
          stripeStatus ||
          "N/A";
        const paidAmount = user.amount_paid ?? 0;
        const subscriptionStart = subscription?.created_at
          ? this.formatDateTime(subscription.created_at)
          : "N/A";
        const subscriptionEnd = subscription?.subscription_end_date
          ? this.formatDateTime(subscription.subscription_end_date)
          : (subscription?.trial_ends_at
            ? this.formatDateTime(subscription.trial_ends_at)
            : "N/A");

        return {
          id: user.id,
          avatar: user.avatar,
          name: user.full_name,
          email: user.email,
          mobile: user.mobile,
          t_shirt_size: user.t_shirt_size,
          registeredon: user.created_at_formatted,
          subscription_name: subscriptionName,
          stripe_status: stripeStatus,
          discount: user.discount,
          invoice_status: invoiceStatus,
          paid_amount: this.formatAmount(paidAmount),
          subscription_start: subscriptionStart,
          subscription_end: subscriptionEnd,
        };
      });

      this.processing = false;
    },

    userPayment({ url = null, searchItem = null, sortBy = null, pageSize = this.pageSize } = {}) {
      this.processing = true;
      let endPoint = "subscription-payments";
      endPoint = url ? url : endPoint;
      this.$axios
        .get(endPoint, {
          params: {
            search: searchItem,
            sort_by: sortBy,
            page_size: pageSize,
          }
        })
        .then((response) => {
          console.log("i have response", response);
          setTimeout(() => this.randerData(response), 1500);
        })
        .catch((error) => {
          console.log(error.response);
          this.processing = false;
        });
    },

    updateRecords(records) {
      this.users = records;
      this.links = records;
    },
    // Record update Function
    userUpdate: function (id) {
      this.$router.push({
        name: "update-user",
        params: { id: id },
        query: { currentPage: this.currentPageNumber, free: true },
      });
    },
    selectAllRecord() {
      if (this.selectAll) {
        let ids = [];
        this.users.forEach((element) => {
          ids.push(element.id);
        });
        this.multipuleIds = [...new Set(ids)];
        console.log(this.multipuleIds);
      } else {
        this.multipuleIds = [];

        console.log(this.multipuleIds);
      }
    },
    deleteBulk() {
      this.$axios
        .post("delete-user-bulk", { ids: this.multipuleIds })
        .then((response) => {
          this.userPayment({});
          this.triggerSwal(response.data.message, "success");
          this.selectAll = false;
          this.multipuleIds = [];
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    formatDate(isoDate) {
      let date = new Date(isoDate);

      let day = date.getDate();
      let month = date.toLocaleString('default', { month: 'long' });
      let year = date.getFullYear();

      let getDaySuffix = (day) => {
        if (day > 3 && day < 21) return "th";
        switch (day % 10) {
          case 1: return "st";
          case 2: return "nd";
          case 3: return "rd";
          default: return "th";
        }
      };

      return `${day}${getDaySuffix(day)} ${month} ${year}`;
    },
  },
};
</script>

<style scoped>
.invoice-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.invoice-column {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.btn-padding{
  padding : 10px 20px !important;
  height : 48px !important;
}

@media (min-width : 1024px) and (max-width: 1992px){
  .custom-gap{
    gap : .5rem !important;
  }
}

@media (max-width: 768px) {
  .invoice-info {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 576px){
  .top-section{
    flex-direction : column !important;
    align-items: flex-start !important;
  }
}

.toolbar-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.toolbar-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
}

@media (max-width : 576px){
  .card-body{
    padding : 0.25rem !important;
  }
  .toolbar-row {
    justify-content: flex-start;
  }

  .toolbar-row:first-child {
    flex-direction: column;
    align-items: flex-start;
  }
  .buttons-container{
    width : 100%;
  }
}
@media (max-width: 768){
  .table > :not(caption) > * > *
  {
    padding: 0.25rem !important;
  }
}
</style>
